[
    {
        "version": "0.1",
        "messageid": "some_msg_id",
        "messagetype": "request",
        "timestamp": "2026-03-04t10:00:00.204z",
        "payload": {
            "command": "clearDashboard",
            "params": {
                "idType": null
            },
            "timeout": 30000
        }
    },
    {
        "version": "0.1",
        "messageid": "some_msg_id",
        "messagetype": "request",
        "timestamp": "2026-03-04t10:00:00.204z",
        "payload": {
            "command": "addDatasets",
            "params": {
                "datasets": [{
                    "idType": "ivaapUri",
                    "ids": [
                        "TO_BE_SET_DYNAMICALY_BEFORE_EXECUTING_COMMAND"
                    ]
                }]
            },
            "timeout": 30000
        }
    },
    {
        "version": "0.1",
        "messageid": "some_msg_id",
        "messagetype": "request",
        "timestamp": "2026-03-04t10:00:00.204z",
        "payload": {
            "command": "openTemplate",
            "params": {
                "id": "TO_BE_SET_DYNAMICALY_BEFORE_EXECUTING_COMMAND"
            },
            "timeout": 30000
        }
    }
]